import React from 'react';

import './scss/style.scss';

import { FooterNavigationSection } from './components';

function FooterNavigation({ items }) {
  return (
    <div className={'navigation'}>
      {items?.map((section, sectionIndex) => (
        <FooterNavigationSection key={sectionIndex} {...section} />
      ))}
    </div>
  );
}

export default FooterNavigation;